import { SceneWord, TransitionEffect } from './scene';
import { MotionType } from './motions';

export interface SceneItem {
  start: number;
  end: number;
  index: number;
  left?: number;
  top?: number;
  height?: number;
  width?: number;
  type: SceneItemType;
  data: SceneItemData | Partial<SceneItemData>;
}

export enum SceneItemType {
  Voiceover = 'voiceover',
  Audio = 'audio',
  Asset = 'asset',
}

export interface SceneAudioItem {
  url: string;
  name: string;
  loop?: boolean;
  playbackRate?: number;
  volume?: number;
  duration: number;
}

export interface SceneVoiceoverItem {
  url: string;
  format: string;
  duration: number;
  voiceoverId: string;
  checksum: string;
  words: SceneWord[];
}

export interface SceneAssetItem {
  assetId: string;
  originalAssetId: string;
  assetPrompt: string;
  transition?: TransitionEffect;
  motion: MotionType;
}

export type SceneItemData =
  | SceneVoiceoverItem
  | SceneAssetItem
  | SceneAudioItem;
